export default {
  state: {
    isCheckbox: false
  },
  actions: {
    changeCkeck({commit}, value) {
        commit('changeCkeck', value)
    },
  },
  mutations: {
    changeCkeck(state, value) {
        state.isCheckbox = value
    },
  },
  getters: {
    lidaTableCheck: state => state.isCheckbox,
  }
}